import { UtcDate } from '@/helpers/date';

export default {
  validate: ({ day, month, year }) => {
    if (!day || !month || !year) return false;

    const claimDate = new UtcDate(year, month - 1, day);
    const maxDate = new UtcDate().subYears(5);
    const todayUtc = new UtcDate();

    return !claimDate.isBefore(maxDate) && !claimDate.isAfter(todayUtc);
  },
  message: (fieldName) => `${fieldName} must be no more than 5 years ago`,
};
